import { render, staticRenderFns } from "./IconLeft.vue?vue&type=template&id=6566ea4b&"
import script from "./IconLeft.vue?vue&type=script&lang=js&"
export * from "./IconLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports